import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../MuroEditorLoadableWrapper';
import { MuroProps } from '../../types';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableEditor = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "muro_editor" */
        './Micro'
      )
  )
);

const MicroLoadable: React.FC<MuroProps> = props => {
  return (
    <EditorLoadableWrapper>
      <LoadableEditor {...props} />
    </EditorLoadableWrapper>
  );
};
MicroLoadable.displayName = 'MicroLoadable';

export default MicroLoadable;
